import { defineStore } from 'pinia';
import storeId from '../storeId';
import type { BasicState } from '@/types/user-type';

export const useBasicStore = defineStore(storeId.BASIC, {
  state: (): BasicState => ({
    windowWidth: window.innerWidth,
    uiMode: 'LG',
    isSearch: false,
    searchWord: ''
  }),
  getters: {},
  actions: {
    updateUiMode(width: number) {
      this.windowWidth = width;
      if (width > 1000) {
        this.uiMode = 'LG';
      } else if (width > 600) {
        this.uiMode = 'MD';
      } else {
        this.uiMode = 'SM';
      }
    }
  }
});
